<template>
	<div class="flex min-h-screen max-h-screen items-stretch">
		<router-view></router-view>
	</div>
</template>
<script>
	export default {}
</script>
